export const NO_DATA = 'noData'
export const SELECTED_PERIOD_NOT_MULTIPLE_CALENDAR_WEEK = 'selectedPeriodNotMultipleCalendarWeek'
export const LOADING_PLEASE_WAIT = 'LoadingPleaseWait'
export const NOT_ACCESS = 'notAccess'
export const CONNECT_SUPPORT = 'connectSupport'
export const DATA_LOADING_ERROR = 'dataLoadingError'
export const DATA_LOADING_ERROR_FILE = 'errorLoadingFile'
export const ERROR_LOADING_DATA_EMPTY_DADA = 'errorLoadingDateEmptyData'
export const DATA_UPDATE_SUCCESS = 'dataUpdateSuccess'
export const DELETE_DATA = 'deleteData'
export const DATA_UPDATE_ERROR = 'dataUpdateError'
export const DATA_CREATE_ERROR = 'dataCreateError'
export const DATA_CREATE_SUCCESS = 'dataCreateSuccess'
export const EQUIPMENT_CREATE_ERROR = 'equipmentCreateError'
export const EQUIPMENT_CREATE_SUCCESS = 'equipmentCreateSuccess'
export const EDIT_REQUEST_SEND_SUCCESS = 'editRequestSendSuccess'
export const EDIT_REQUEST_SEND_CONFLICT = 'editRequestSendConflict'
export const EDIT_REQUEST_ACCEPT_SUCCESS = 'editRequestAcceptSuccess'
export const EDIT_REQUEST_REJECT_WARNING = 'editRequestRejectWarning'
export const SHIFT_TRANSFER_ERROR = 'shiftTransferError'
export const SEND_SHIFT_TRANSFER_SUCCESS = 'sendShiftTransferSuccess'
export const SEND_SHIFT_TRANSFER_ERROR = 'sendShiftTransferError'
export const SHIFT_ACCEPTANCE_ERROR = 'shiftAcceptanceError'
export const ACCEPT_SHIFT_SUCCESS = 'acceptShiftSuccess'
export const ACCEPT_SHIFT_ERROR = 'acceptShiftError'
